/**
* Opens a modal allowing user to enter some values
*/
app.directive('monthlyPaymentModal', ["$templateRequest", "$compile", "BrowserStorageService", function($templateRequest, $compile, BrowserStorageService) {
	return {
		restrict: 'E',
		//templateUrl: 'monthly-payment.html',
		scope: {
			show: '=',
			minHousePrice: '=',
			maxHousePrice: '=',
			callback: '&?'
		},
		replace: false,
		link: function($scope, element, attrs) {
			var oldValues = BrowserStorageService.LocalStorage.GetItem('monthlyPayment');

			$scope.minPrice = oldValues && oldValues.minPrice ? oldValues.minPrice : undefined;
			$scope.maxPrice = oldValues && oldValues.maxPrice ? oldValues.maxPrice : undefined;
			$scope.interest = oldValues && oldValues.interest ? oldValues.interest : "1,20";
			$scope.time = oldValues && oldValues.time ? oldValues.time : 25;
			$scope.savings = oldValues && oldValues.savings ? oldValues.savings : undefined;
			$scope.used = oldValues && oldValues.used ? oldValues.used : false;
			$scope.minHousePriceInternal = undefined;
			$scope.maxHousePriceInternal = undefined;

			$templateRequest('monthly-payment.html').then(function(tpl) {
				angular.element('body').append($compile(tpl)($scope));
			});

			$scope.hideModal = function() {
				$scope.show = false;
			};

			$scope.calculate = function() {
				var minPrice = parseInt($scope.minPrice) || 0;
				var maxPrice = $scope.maxPrice ? parseInt($scope.maxPrice) : undefined;
				maxPrice = maxPrice < minPrice ? 0 : maxPrice;
				var savings = parseInt($scope.savings) || 0;
				var series = parseInt($scope.time) * 12;
				var a = parseFloat($scope.interest.replace(/[,]/, '.')) / 1200;
				var b = Math.pow((1 + a), series);
				var c = Math.pow((1 + a), series) - 1;
				var multiplier = (a * b) / c;

				$scope.minHousePriceInternal = Math.round((minPrice / multiplier + parseInt(savings)) / 1000) * 1000;
				if (minPrice < maxPrice) {
					$scope.maxHousePriceInternal = Math.round((maxPrice / multiplier + parseInt(savings)) / 1000) * 1000;
				} else {
					$scope.maxHousePriceInternal = '';
				}
			};

			$scope.$watch('[minPrice, maxPrice, interest, time, savings]', $scope.calculate, true);

			/**
			 * NOTE: minHousePrice and maxHousePrice is binded to SearchModel.query.GetPriceConstraints().min/max
			 */
			$scope.setPrices = function() {
				/* Mark as used */
				if (!$scope.used) {
					$scope.used = true;
					BrowserStorageService.LocalStorage.SetItem('monthlyPayment', {
						minPrice: $scope.minPrice,
						maxPrice: $scope.maxPrice,
						interest: $scope.interest,
						time: $scope.time,
						savings: $scope.savings,
						used: $scope.used
					});
				}
				/* Update prices */
				if ($scope.minHousePriceInternal) {
					$scope.minHousePrice = Math.round($scope.minHousePriceInternal / 1000);
				}
				// if ($scope.maxHousePriceInternal) {
					$scope.maxHousePrice = Math.round($scope.maxHousePriceInternal / 1000) !== 0 ? Math.round($scope.maxHousePriceInternal / 1000) : '';
				// }
			};

			// Init
			$scope.calculate();
			/* Old values are one time use only for settings prices */
			if (!$scope.used) {
				$scope.setPrices();
			}

			/**
			 *
			 */
			$scope.search = function() {
				// Set prices
				$scope.setPrices();

				// Set localStorage to "wait for activation"
				BrowserStorageService.LocalStorage.SetItem('monthlyPayment', {
					minPrice: $scope.minPrice,
					maxPrice: $scope.maxPrice,
					interest: $scope.interest,
					time: $scope.time,
					savings: $scope.savings,
					used: false
				});

				$scope.hideModal();

				if ($scope.callback) {
					$scope.callback();
				}
			};
		}
	};
}]);